import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { PosModifyComponent } from '../../points-of-sale/pos-modify/pos-modify.component';
import { GuardService } from '../../service/guard.service';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivatePosModifyGuard {
  constructor(private readonly guardService: GuardService) {}
  canDeactivate(component: PosModifyComponent): Observable<boolean> | boolean {
    return this.guardService.canDeactivate(component);
  }
}
